import React from 'react';
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

const BroadcastResolutions = ({ setStreamResolutions }) => {
  const changeVideoResolution = event => {
    const value = event.target.value;
    const resolutions = JSON.parse(value);
    setStreamResolutions(resolutions);
  };

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold">
        Video Broadcast Resolution
      </Typography>
      <Typography variant="subtitle2" mb={1}>
        Please note: Higher resolution broadcasts require much more bandwidth and may cause
        additional latency in the broadcast stream.
      </Typography>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue={JSON.stringify({ height: 240, width: 426 })}
          name="radio-buttons-group"
          onChange={changeVideoResolution}
        >
          <FormControlLabel
            value={JSON.stringify({ height: 240, width: 426 })}
            control={<Radio size="small" sx={{ padding: 0.75 }} />}
            label={<Typography sx={{ fontSize: 14 }}>Standard Resolution</Typography>}
          />
          <FormControlLabel
            value={JSON.stringify({ height: 480, width: 854 })}
            control={<Radio size="small" sx={{ padding: 0.75 }} />}
            label={<Typography sx={{ fontSize: 14 }}>High Resolution</Typography>}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default BroadcastResolutions;
